// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2559) return "static/chunks/2559.b4cd970596a0394d.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 922 ? "c15bf2b0" : chunkId) + "-" + {"922":"83b0c24ffa6477c7","6498":"f67415ddb156cf23","9498":"92c3c60bcba8822e"}[chunkId] + ".js";
};